<template>
	<div
		class="avatar-container"
		@click="link ? goToProfile() : null"
		:class="{ link: link }"
	>
		<v-avatar :color="color" :size="size" :src="avatar" :class="{shadow: shadow}">
			<div
				v-if="!avatar && !isAvatarLoading"
				:class="[
					'white--text font-weight-medium',
					{
						'font-7': xxs,
						'font-10': xs,
						'font-12': sm,
						'font-52': bg,
						'font-14': !xxs && !xs && !sm && !bg && !xxl,
					},
				]"
			>
				<template v-if="firstLetter">
					{{ firstLetter }}
				</template>
				<template v-else>
					<div class="px-2 py-2 white rounded-sm">
						<v-icon>$empty-avatar</v-icon>
					</div>
				</template>
			</div>
			<v-progress-circular
				v-if="isAvatarLoading"
				indeterminate
				color="primary"
			></v-progress-circular>
			<v-img
				v-if="!isAvatarLoading && avatar"
				class="avatar-img"
				:src="avatar.url"
			/>
		</v-avatar>
		<!--TODO: Zablokować wyświetlanie aktywności jeśli user ten sam co zalogowany lub gdy wybryany user ma status niewidocznego-->
		<div
			v-if="showActive"
			class="avatar-user-active d-flex justify-center align-center"
		>
			<div class="success"></div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
	name: "Avatar",
	props: {
		xxs: {
			type: Boolean,
			default: false,
		},
		xs: {
			type: Boolean,
			default: false,
		},
		sm: {
			type: Boolean,
			default: false,
		},
		md: {
			type: Boolean,
			default: false,
		},
		bg: {
			type: Boolean,
			default: false,
		},
		xxl: {
			type: Boolean,
			default: false,
		},
		group: {
			type: Object,
			default: null,
		},
		user: {
			type: Object,
			default() {
				return this.group ? null : this.$store.state.auth.user;
			},
		},
		hideActivity: {
			type: Boolean,
			default: false,
		},
		isRoute: {
			type: Boolean,
			default() {
				return !!(
					(this.user && this.user.id) ||
					(this.group && this.group.id)
				);
			},
		},
		link: {
			type: Boolean,
			default: false,
		},
		chatRoom: {
			type: Object,
			default: null
		},
		bubble: {
			type: Boolean,
			default: false
		},
		shadow: {
			type: Boolean,
			default: false
		},
		muted: {
			type: Boolean,
			default: false
		},
		multiple: {
			type: Boolean,
			default: false
		},
		users: {
			type: Array,
		}
	},
	data() {
		return {
			avatar: null,
		};
	},
	computed: {
		...mapGetters({
			authUser: "auth/user",
			colors: "dictionaries/avatarColors",
			isAvatarLoading: "auth/isAvatarLoading",
			activeUsers: 'application/activeUsers'
		}),
		firstLetter() {
			if(this.users && this.users.length && this.multiple) {
				let name = '';
				this.users.forEach((user) => {
					if(user.name) {
						name += user.name.charAt(0).toUpperCase();
					}
				});
				if(name.length > 3) {
					return name.substring(0, 3) + '+';
				}
				return name;
			}
			if (this.user) {
				if (this.user.name) {
					return this.user.name.charAt(0).toUpperCase();
				}
				return this.user.email.charAt(0).toUpperCase();
			}
			return "";
		},
		chatFirstLetters() {
			if(this.chatRoom) {
				//
			}
			return null;
		},
		color() {
			if(this.muted) {
				return 'grey lighten-2';
			}
			if (!this.avatar) {
				if(this.users) {
					return this.firstLetter ? this.colors[this.firstLetter[0].toLowerCase()] : "blue lighten-2";
				}
				return this.firstLetter ? this.colors[this.firstLetter.toLowerCase()] : "grey lighten-2";
			}
			return "transparent";
			//return `$avatar-${this.firstLetter}`;
		},
		showActive: function () {
			if(this.users) {
				return false
			}
			if (this.user) {
				if(!this.xs && !this.xxs && !this.hideActivity) {
					if(this.authUser.id == this.user.id) {
						return true;
					}
					if(this.activeUsers.findIndex(x => x.id == this.user.id) != -1) {
						return true;
					}
				}
			}
			return false;

			// return !this.hideActivity && this.active && !this.xs && !this.sm
		},
		active: function () {
			if (this.user && this.user.id)
				return this.authUser.id === this.user.id;
			else {
				return false;
			}
		},
		size: function () {
			switch (true) {
				case this.xxs:
					return 15;
				case this.xs:
					return 20;

				case this.sm:
					return 24;

				case this.md:
					return 60;

				case this.bg:
					return 128;

				case this.xxl:
					return 150;

				case this.bubble:
					return 56;

				default:
					return 40;
			}
		},
		isAvatar() {
			if (this.user) {
				if (this.user.avatar) {
					return "transparent";
				}
			}
			return false;
		},
	},
	watch: {
		"group.avatar.url": {
			handler() {
				this.setAvatar();
			},
			immediate: true,
			deep: true,
		},
		"user.avatar": {
			handler() {
				this.setAvatar();
			},
			immediate: true,
			deep: true,
		},
	},
	methods: {
		setAvatar() {
			if(this.users) {
				this.avatar = null
			}
			else if (this.user) {
				this.avatar = this.user.avatar
			}
			else if (this.group) {
				if (this.group.avatar) {
					this.avatar = this.group.avatar
				}
				else {
					this.avatar = {
						url: require('@/assets/images/group/avatar.png')
					}
				}
			}
		},
		getColor(i) {
			return `#${Math.floor(Math.random() * 16777215 + i).toString(16)}`;
		},
		goToProfile() {
			if (this.isRoute) {
				this.$router
					.push({
						name: "Profile",
						params: { userID: this.user.id },
					})
					.catch(() => {});
			}
		},
	},
};
</script>

<style lang="scss">
.wall-card {
	&:not(&--accent) {
		.avatar-container {
			> div {
				&.avatar-user-active {
					background-color: var(--v-background-lighten1);
				}
			}
		}
	}
	&--accent {
		.avatar-container {
			> div {
				&.avatar-user-active {
					background-color: var(--v-accent-lighten2);
				}
			}
		}
	}
}

.avatar-container {
	position: relative;
	> div {
		&.avatar-user-active {
			position: absolute;
			width: 13px;
			height: 13px;
			background: #fff;
			right: 0;
			bottom: 0;
			border-radius: 100%;
			> div {
				height: 8px;
				width: 8px;
				border-radius: 100%;
			}
		}
	}
}

.avatar-img {
	object-fit: cover;
}
</style>
